

const Layout = ({ children }) => {
  return (
    <div className="container-fluid">
      {/* <div style={{ width: '85%',margin:'auto',border:'1px solid' }}> */}
        {children}
      {/* </div> */}

    </div>
  );
};

export default Layout;
